import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { EcmpAffiliateLogo } from '@core/navigation-store';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-calculate-form-sticker',
  templateUrl: './calculate-form-sticker.component.html',
  styleUrls: [
    './calculate-form-sticker.component.essent.scss',
    './calculate-form-sticker.component.ed.scss',
  ],
  standalone: true,
  imports: [CommonModule, AutomationIdDirective],
})
export class CalculateFormStickerComponent {
  public readonly title = input<string>();
  public readonly subtitle = input<string>();
  public readonly sticker = input<Partial<HTMLImageElement>>();

  public readonly stickerContent = input<string>();
  public readonly stickerFocusLine = input<number>();
  public readonly stickerTheme = input<string>();

  public readonly affiliateLogo = input<EcmpAffiliateLogo | null>();

  public readonly stickerContentLineCount = computed(
    () => this.stickerContentByLine().length
  );

  public readonly stickerContentByLine = computed(() => {
    const content = this.stickerContent();
    return content ? content.split(/\n/) : [];
  });

  public readonly stickerSrc = computed(() => {
    const sticker = this.sticker();
    return sticker ? sticker.src : '';
  });

  public readonly stickerAlt = computed(() => {
    const sticker = this.sticker();
    return sticker ? sticker.alt : '';
  });
}
